import { CountriesModel } from '@app/pages/main/pages/startup-countries/models/countries.interfaces';
import { GridDataAdapterService } from '@app/shared/grid/services/grid-data-adapter.service';
import { GridTopicFieldRenderer } from '@app/shared/grid/grid-options';
import { InstitutionalReviewBoardFilterMode } from '@app/origami-api/constants/institutional-review-board-filter-mode';
import { ConfigServiceModel } from '@app/origami-api/services/config.service';
import { IrbTopic } from '@app/origami-api/utils/topic-utils';

export namespace IrbEcModel {
  import StateToolbarBtn = CountriesModel.StateToolbarBtn;

  export enum InstitutionalReviewBoardStatus {
    Pending = 1,
    Submitted = 2,
    ConditionalApproval = 3,
    Approved = 4,
    Rejected = 5,
  }

  export enum ErbEcTabPages {
    DETAILS = 1,
    DOCUMENTS,
    AMENDMENTS,
    // COUNTRIES,
    SITES,
    COMMUNICATION_LOG,
    AGENCY_SUBMISSION,
  }

  export interface IrbEcLayoutActionsParams {
    icon?: string;
    text?: string;
    showWhen?: StateToolbarBtn;
    defaultHidden?: boolean;
    activeWhen?: StateToolbarBtn;
    defaultDisable?: boolean;
  }

  export interface IrbEcCommonActionsParams {
    investigativeSiteId: number;
    centralIrbId?: number;
    forceDisable: boolean;
    isCentralIrbRequired?: boolean;
  }

  export interface ExtendedGridDataAdapter extends GridDataAdapterService<any, any, any> {
    countRows: number;
    getRequiredDocuments: boolean;
  }

  export interface IrbsColumnOptions {
    topicTypes?: string;
    columnsFromTopicTypeTopicFields?: string;
    topicTypeRenderers: GridTopicFieldRenderer<any, any>[];
    domainForm?: ConfigServiceModel.Form;
  }

  export interface IrbsLayoutViewTypeOptions {
    prefix: string;
    viewType: IrbsLayoutViewType;
    baseTopicTypeName: string;
    baseTopicTypeId: number;
    skipDefaultRefresh: boolean;

    country?: {
      id: number;
      iso: string;
      filterMode?: InstitutionalReviewBoardFilterMode;
    };
    site?: {
      id: number;
      siteMainIrbId: number;
      filterMode?: InstitutionalReviewBoardFilterMode;
    };
    amendment?: {
      id: number;
      filterMode?: InstitutionalReviewBoardFilterMode;
    };
  }

  export enum IrbsLayoutViewType {
    IRB_MAIN_VIEW = 1,
    IRB_COUNTRY_VIEW,
    IRB_SITES_VIEW,
    IRB_AMENDMENTS_VIEW,
    IRB_ADD_EXIST_VIEW,
    IRB_CREATE_SITE_VIEW,
  }

  export interface SSUIrbEcCodingOptions {
    entities: IrbTopic;
    codingLocation?: IrbsLayoutViewType;
  }
}
